import ReactDOM from 'react-dom/client';
import RootApplication from './RootApplication';
import { BrowserRouter } from 'react-router-dom';
import './styles/zyvgo-design.css';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <BrowserRouter>
    <RootApplication />
  </BrowserRouter>
);
